var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-input',{attrs:{"fancy":_vm.fancy,"label":_vm.label,"value":_vm.currentInputValue},on:{"input":function($event){return _vm.onInput($event)},"blur":function($event){return _vm.onBlur()},"keyup":function($event){return _vm.onKeyUp($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }